import { render, staticRenderFns } from "./cooperation.vue?vue&type=template&id=50e10270&scoped=true&"
import script from "./cooperation.vue?vue&type=script&lang=js&"
export * from "./cooperation.vue?vue&type=script&lang=js&"
import style0 from "./cooperation.vue?vue&type=style&index=0&id=50e10270&prod&lang=scss&scoped=true&"
import style1 from "./cooperation.vue?vue&type=style&index=1&id=50e10270&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e10270",
  null
  
)

export default component.exports